"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _MemoizeKeyError = _interopRequireDefault(require("./MemoizeKeyError"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
/**
 * To initialize, run `const memoize = new Memoize()`
 * To set, run `memoize.set([key], value)` (note that you must always pass an array)
 * To get, run `memoize.get([key])` (note that you must always pass an array)
 */

const allKeysMatch = (keys1, keys2) => {
  return keys1.length === keys2.length && keys1.every((key, i) => key === keys2[i]);
};
const validateKeys = keys => {
  if (!keys || !Array.isArray(keys)) {
    throw new _MemoizeKeyError.default('Keys must be an array and is required');
  }
};
class Memoize {
  constructor() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _defineProperty(this, "memoizedItems", []);
    _defineProperty(this, "maxItems", Infinity);
    const {
      max
    } = options;
    if (max) {
      this.maxItems = max;
    }
  }
  getIndexOfObject(keysToQuery) {
    return this.memoizedItems.findIndex(_ref => {
      let {
        keys
      } = _ref;
      return allKeysMatch(keysToQuery, keys);
    });
  }
  deleteObjectByKeyIfExists(keysToQuery) {
    const indexOfFoundObject = this.getIndexOfObject(keysToQuery);
    if (indexOfFoundObject === -1) {
      return;
    }
    this.memoizedItems.splice(indexOfFoundObject, 1);
  }
  set(keys, value) {
    validateKeys(keys);
    this.deleteObjectByKeyIfExists(keys);
    if (this.memoizedItems.length >= this.maxItems) {
      // TODO: Create an LRU policy - for now always remove oldest item
      this.memoizedItems.splice(0, 1);
    }
    this.memoizedItems.push({
      keys,
      value
    });
  }
  get(keysToQuery) {
    validateKeys(keysToQuery);
    const indexOfFoundObject = this.getIndexOfObject(keysToQuery);
    if (indexOfFoundObject === -1) {
      return undefined;
    }
    return this.memoizedItems[indexOfFoundObject].value;
  }
}
_defineProperty(Memoize, "KeyError", _MemoizeKeyError.default);
var _default = Memoize;
exports.default = _default;